import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';

export function AdminTools() {
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  
  const triggerSync = async () => {
    setSyncing(true);
    setError(null);
    setSyncResult(null);
    
    try {
      const response = await fetch('/.netlify/functions/trigger-sync');
      
      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
      
      const result = await response.json();
      setSyncResult(result);
      
      // Log the result for debugging
      console.log('Sync result:', result);
    } catch (err) {
      console.error('Sync error:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
    } finally {
      setSyncing(false);
    }
  };
  
  // Only render in development or with admin param
  const isAdmin = process.env.NODE_ENV === 'development' || 
                  new URLSearchParams(window.location.search).has('admin');
  
  if (!isAdmin) return null;
  
  return (
    <div className="fixed top-4 right-4 z-50 bg-white shadow-lg rounded-lg p-4 w-80">
      <h3 className="font-bold text-lg mb-2">Admin Tools</h3>
      
      <div className="space-y-4">
        <div>
          <button 
            onClick={triggerSync}
            disabled={syncing}
            className={`flex items-center justify-center gap-2 px-4 py-2 rounded-md w-full ${
              syncing ? 'bg-gray-300' : 'bg-blue-500 hover:bg-blue-600'
            } text-white`}
          >
            {syncing ? (
              <>
                <RefreshCw className="w-4 h-4 animate-spin" />
                Syncing...
              </>
            ) : (
              <>
                <RefreshCw className="w-4 h-4" />
                Sync Foundation Data
              </>
            )}
          </button>
        </div>
        
        {error && (
          <div className="p-3 bg-red-100 text-red-800 rounded-md text-sm">
            {error}
          </div>
        )}
        
        {syncResult && (
          <div className="p-3 bg-green-100 text-green-800 rounded-md text-sm">
            <p><strong>Status:</strong> {syncResult.success ? 'Success' : 'Failed'}</p>
            {syncResult.success && (
              <>
                <p><strong>Foundations Processed:</strong> {syncResult.details?.count || 0}</p>
                {syncResult.details?.syncTime && (
                  <p><strong>Time taken:</strong> {Math.round(syncResult.details.syncTime)} seconds</p>
                )}
              </>
            )}
            {!syncResult.success && syncResult.error && (
              <p><strong>Error:</strong> {syncResult.error}</p>
            )}
          </div>
        )}
        
        <div className="text-xs text-gray-500 border-t border-gray-200 pt-2 mt-1">
          <p>
            This tool triggers the data sync process to update the Supabase database with the latest foundation data.
          </p>
          <p className="mt-1">
            Note: The sync process may take several minutes to complete depending on the amount of data.
          </p>
        </div>
      </div>
    </div>
  );
}
